import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "confirm-title font-weight-bold mb-3"
};
const _hoisted_2 = {
  class: "confirm-text pb-1"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
                                                                  
  const _component_mf_button = _resolveComponent("mf-button");
                                                      
                                                                        
                                                        
                                                            
  const _directive_html_safe = _resolveDirective("html-safe");
  return _openBlock(), _createBlock(_component_v_dialog, {
    modelValue: $options.openModal,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $options.openModal = $event),
    class: "confirm-dialog",
    persistent: "",
    width: "550px"
  }, {
    default: _withCtx(() => [_createVNode(_component_v_card, {
      class: "py-6 px-6 rounded-lg"
    }, {
      default: _withCtx(() => [_createVNode(_component_v_card_text, {
        class: "pa-0 mb-5"
      }, {
        default: _withCtx(() => [$props.title ? (_openBlock(), _createElementBlock("h4", _hoisted_1, _toDisplayString($props.title), 1)) : _createCommentVNode("", true), _withDirectives(_createElementVNode("span", _hoisted_2, null, 512), [[_directive_html_safe, $options.formattedMessage]]), _renderSlot(_ctx.$slots, "additional-content", {}, undefined, true)]),
        _: 3
      }), !$props.hideActionButtons ? (_openBlock(), _createBlock(_component_v_card_actions, {
        key: 0
      }, {
        default: _withCtx(() => [_createVNode(_component_v_row, {
          justify: "end"
        }, {
          default: _withCtx(() => [!$props.hideCancel ? (_openBlock(), _createBlock(_component_mf_button, {
            key: 0,
            ref: "cancelButton",
            class: "mr-4",
            color: $props.cancelColor,
            disabled: $props.cancelDisabled,
            label: $props.cancelText,
            loading: $props.cancelLoading,
            outlined: "",
            onClick: _cache[0] || (_cache[0] = $event => $options.onCancel())
          }, null, 8, ["color", "disabled", "label", "loading"])) : _createCommentVNode("", true), !$props.hideConfirm ? (_openBlock(), _createBlock(_component_mf_button, {
            key: 1,
            ref: "confirmButton",
            class: "ma-0",
            color: $props.confirmColor,
            disabled: $props.confirmDisabled,
            label: $props.confirmText,
            loading: $props.confirmLoading,
            onClick: _cache[1] || (_cache[1] = $event => $options.onConfirm())
          }, null, 8, ["color", "disabled", "label", "loading"])) : _createCommentVNode("", true)]),
          _: 1
        })]),
        _: 1
      })) : _createCommentVNode("", true)]),
      _: 3
    })]),
    _: 3
  }, 8, ["modelValue"]);
}

/* Vuetify */
import { VCardText as _component_v_card_text, VCardActions as _component_v_card_actions, VCard as _component_v_card } from "vuetify/components/VCard"
import { VDialog as _component_v_dialog } from "vuetify/components/VDialog"
import { VRow as _component_v_row } from "vuetify/components/VGrid"

